import { render, staticRenderFns } from "./customerReport.vue?vue&type=template&id=a1ddda64&scoped=true&"
import script from "./customerReport.vue?vue&type=script&lang=js&"
export * from "./customerReport.vue?vue&type=script&lang=js&"
import style0 from "./customerReport.vue?vue&type=style&index=0&id=a1ddda64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ddda64",
  null
  
)

export default component.exports